import { render, staticRenderFns } from "./SlideImgManage.vue?vue&type=template&id=07a732e6&scoped=true"
import script from "./SlideImgManage.vue?vue&type=script&lang=js"
export * from "./SlideImgManage.vue?vue&type=script&lang=js"
import style0 from "./SlideImgManage.vue?vue&type=style&index=0&id=07a732e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a732e6",
  null
  
)

export default component.exports